import { Epic, combineEpics } from 'redux-observable';
import { isOfType, action } from 'typesafe-actions';
import { filter, mergeMap, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { push } from 'connected-react-router';
import { toastr } from 'react-redux-toastr';
import { getStartPage } from 'config/pages';

import { IRootAction, IRootState } from 'reducers';
import { ActionTypes } from 'reducers/user';
import { ActionTypes as appActions } from 'reducers/app';

import * as userAPI from 'api/user';

const login: Epic<IRootAction, any, IRootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.PERFORM_LOGIN)),
    mergeMap<any, any>(({ payload: { values, resetForm } }) =>
      from(userAPI.login(values)).pipe(
        mergeMap<any, any>((response: any) => {
          if (!response) {
            toastr.error('Запрос прерван', '');
            return of(
              action(appActions.TOGGLE_BLOCKING_UI, false),
              action(ActionTypes.PERFORM_LOGIN_FAILURE),
            );
          }
          if (response.success) {
            return of(
              action(appActions.TOGGLE_BLOCKING_UI, false),
              action(ActionTypes.PERFORM_LOGIN_SUCCESS, response.user),
              push(getStartPage(response.user.roles)),
            );
          }
          toastr.error('Ошибка авторизации', response.error || '');
          if ((window as any)['grecaptcha']) (window as any)['grecaptcha'].reset();
          resetForm();
          return of(
            action(appActions.TOGGLE_BLOCKING_UI, false),
            action(ActionTypes.PERFORM_LOGIN_FAILURE),
          );
        }),
        catchError(error => {
          toastr.error('Запрос прерван', '');
          return of(`Error: ${error}`, action(appActions.TOGGLE_BLOCKING_UI, false));
        })
      )
    ),
  );

const checkStatus: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.IS_LOGINED_REQUEST)),
    mergeMap<any, any>(() =>
      from(userAPI.checkLogin()).pipe(
        mergeMap<any, any>(({ isLogined, user }: any) => {
          if (isLogined) {
            return of(
              action(ActionTypes.IS_LOGINED, { isLogined, user }),
            );
          }
          // toastr.error('Вы не авторизованы. Выполните вход', '');
          return of(
            action(ActionTypes.IS_LOGINED, { isLogined, user }),
            push('/auth'),
          );
        }),
      )
    )
  );

const logout: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.LOGOUT)),
    mergeMap<any, any>(() =>
      from(userAPI.logout()).pipe(
        mergeMap<any, any>(({ success }: any) => {
          if (success) {
            toastr.success('Выход из системы', '');
            return of(
              action(ActionTypes.LOGOUT_SUCCESS),
              push('/auth'),
            );
          }
          toastr.error('Ошибка выхода из системы', '');
          return of(action(ActionTypes.LOGOUT_FAILURE));
        }),
      )
    )
  );

const restorePassword: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.RESTORE_PASSWORD_REQUEST)),
    mergeMap<any, any>(({ payload: { values, resetForm } }) =>
      from(userAPI.restorePassword(values)).pipe(
        mergeMap<any, any>((response: any) => {
          if (response.success) {
            toastr.success('Новый пароль отправлен на E-mail', '');
            return of(
              action(appActions.TOGGLE_BLOCKING_UI, false),
              push('/auth'),
            );
          }
          toastr.error(response.error, '');
          if ((window as any)['grecaptcha']) (window as any)['grecaptcha'].reset();
          resetForm();
          return of(
            action(appActions.TOGGLE_BLOCKING_UI, false),
            action(ActionTypes.RESTORE_PASSWORD_FAILURE),
          );
        }),
        catchError(error => of(`Error: ${error}`, action(appActions.TOGGLE_BLOCKING_UI, false)))
      )
    ),
  );

export default combineEpics(
  login,
  checkStatus,
  logout,
  restorePassword,
);
